import { defineComponent as r, createBlock as a, openBlock as l, unref as p, mergeProps as c, withCtx as i, createElementVNode as o } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const h = /* @__PURE__ */ r({
  name: "IconArchive",
  __name: "IconArchive",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (v, e) => (l(), a(p(m), c(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        o("path", { d: "M8.25 11A.75.75 0 0 1 9 10.25h6a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 11" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M3.5 3.25A1.25 1.25 0 0 0 2.25 4.5v3a1.25 1.25 0 0 0 1 1.225V19.5a1.25 1.25 0 0 0 1.25 1.25h15a1.25 1.25 0 0 0 1.25-1.25V8.725a1.25 1.25 0 0 0 1-1.225v-3a1.25 1.25 0 0 0-1.25-1.25h-17m15.75 5.5H4.75v10.5h14.5V8.75m1-1.5v-2.5H3.75v2.5h16.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
